export default function TriskelionMark({
  size = 40,
  spin = false,
  className = "",
  armColor = "#F5C518",
  hubColor = "#E52E39",
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={`${spin ? "animate-via-spin" : ""} ${className}`}
      aria-hidden="true"
    >
      <g fill="none" stroke={armColor} strokeWidth="8" strokeLinecap="round">
        {[0, 120, 240].map((r) => (
          <path key={r} d="M50 50 C 46 32, 58 16, 78 22" transform={`rotate(${r} 50 50)`} />
        ))}
      </g>
      <circle cx="50" cy="50" r="8" fill={hubColor} />
    </svg>
  );
}
